import { render, staticRenderFns } from "./PaymentPopup.vue?vue&type=template&id=aaa16d74&scoped=true"
import script from "./PaymentPopup.vue?vue&type=script&lang=js"
export * from "./PaymentPopup.vue?vue&type=script&lang=js"
import style0 from "./PaymentPopup.vue?vue&type=style&index=0&id=aaa16d74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa16d74",
  null
  
)

export default component.exports